import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Firewood = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my firewood business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps firewood businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for firewood businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most firewood businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my firewood business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like firewood. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Firewood - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Firewood CRM", url: "/industries/firewood" }
  ];

  const industryData = {
    name: 'Firewood Delivery',
    title: 'Automate Seasonal Orders & Build Year-Round Delivery Routes',
    subtitle: 'Capture orders early, automate delivery scheduling, and build a base of recurring seasonal customers',
    icon: '🪓',
    challenges: [
      'All orders come in last minute',
      'Hard to plan delivery routes',
      'One-time customers don\'t reorder',
      'Weather affects delivery schedule',
      'Seasonal cash flow gaps'
    ],
    solutions: [
      'Early season ordering automation',
      'Route optimization system',
      'Automatic reorder campaigns',
      'Weather-based scheduling',
      'Summer wood splitting upsells'
    ],
    features: [
      'Customer CRM with order history',
      'Online ordering system',
      'Delivery route optimization',
      'Seasonal reorder reminders',
      'Weather notifications',
      'Cord/measurement tracking',
      'Payment automation',
      'Review requests'
    ],
    results: [
      '70% become annual customers',
      'Optimize delivery routes by 40%',
      'Fill orders 2 months early',
      '£4.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Firewood UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for firewood businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for firewood UK, firewood business software, firewood customer management, firewood lead generation UK"
        url="/industries/firewood"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Firewood;